var React = require('react');

function IconMailO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M831.2 385v77.7L511.7 657 194.2 462.7V385l317.5 194.3L831.2 385","key":0}),React.createElement("path",{"d":"M943.5 256.2H81c-8.7 0-15.7 7.1-15.6 15.6l.4 70.7-.4 403.2v70.7c0 8.6 6.9 15.6 15.7 15.6h862.5c8.7 0 15.7-7.1 15.7-15.6V271.8c-.1-8.6-7.1-15.6-15.8-15.6zm-56.4 488.6c0 6.3-5.8 11.5-13.1 11.5H151.8c-7.3 0-13.1-5.2-13.1-11.5v-52.1l.4-297.4-.3-52.1c0-6.3 5.8-11.5 13-11.5h722.3c7.3 0 13.1 5.2 13.1 11.5v401.6z","key":1})]);
}

IconMailO.displayName = "IconMailO";

IconMailO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconMailO;

IconMailO.default = IconMailO;
